import { type RouteRecordRaw } from 'vue-router'

import { eModules } from '@/constants'
import Layout from '@/layout/index.vue'

export const factoryStudioRoutes: RouteRecordRaw[] = [
  {
    path: '/studio/regions',
    components: {
      default: () => import('../views/regions/index.vue'),
      navbar: () => import('../views/navbar/index.vue'),
    },
    name: 'Regions',
    meta: {
      title: 'Regions',
      icon: 'regions',
      affix: true,
      layout: Layout,
      allowedModules: [eModules.FACTORY_STUDIO],
    },
  },
  {
    path: '/studio/zones',
    name: 'Zones',
    components: {
      default: () => import('../views/zones/index.vue'),
      navbar: () => import('../views/navbar/index.vue'),
    },
    meta: {
      title: 'Zones',
      icon: 'zones',
      affix: true,
      layout: Layout,
      allowedModules: [eModules.FACTORY_STUDIO],
    },
  },
  {
    path: '/studio/devices',
    components: {
      default: () => import('../views/devices/index.vue'),
      navbar: () => import('../views/navbar/index.vue'),
    },
    name: 'Devices',
    meta: {
      title: 'Devices',
      icon: 'devices',
      affix: true,
      layout: Layout,
      allowedModules: [eModules.FACTORY_STUDIO],
    },
  },
  {
    path: '/studio/scheduler',
    components: {
      default: () => import('../views/schedulers/index.vue'),
      navbar: () => import('../views/navbar/index.vue'),
    },
    name: 'Scheduler',
    meta: {
      title: 'Scheduler',
      icon: 'scheduler',
      affix: true,
      layout: Layout,
      allowedModules: [eModules.FACTORY_STUDIO],
    },
  },
]
